import { routes } from 'src/routes/index.routes'
import { useAuthStore } from 'src/store/auth'

export const useAuth = () => {
  const handleUser = useAuthStore((state) => state.handleUser)
  const addUser = (user) => {
    handleUser(user)
  }

  const handleLogout = () => {
    localStorage.clear()
    window.location.href = routes.login
  }
  return { addUser, handleLogout }
}
